import $ from "jquery";
import Swiper, { Navigation, Pagination, Scrollbar } from "swiper";
import "swiper/swiper-bundle.css";

Swiper.use([Navigation, Pagination, Scrollbar]);

setTimeout(function(){
  $(".history_slider").each(function(index){
    const $slider = $(this);
    const $slides = $slider.find(".history_slider__slides");
    const $prev   = $slider.find(".history_slider__prev");
    const $next   = $slider.find(".history_slider__next");
    const $pagination = $slider.find(".swiper-pagination_history_slider");

    console.log(`Initializing Swiper for history_slider #${index}`, $slider);

    // Initialize Swiper and store the instance
    const mySwiper = new Swiper($slides[0], {
      breakpoints: {
        1180: {
          slidesPerView: 1,
        }
      },
      spaceBetween: 20,
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
      navigation: {
        nextEl: $next[0],
        prevEl: $prev[0],
      },
      pagination: {
        el: $pagination[0],
        clickable: true,
        renderBullet: function (index, className) {
          // index starts at 0, so add 1 to show 1-based slide numbering
          return '<span class="history_date_nav ' + className + '" id="' + index + '"></span>';
        },
      },
      on: {
        slideChange: function () {
          // Log on each slide change
          console.log('Slide changed. Current active index:', this.activeIndex);
        },
      },
    });

 });
}, 300);
